import React, { useState, useEffect, useCallback } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';
import './Toast.css';

// --- Simple global emitter (no context needed) ---
let listeners = [];
let counter = 0;

export function showToast(message, type = 'info', duration = 5000) {
  const id = ++counter;
  listeners.forEach(fn => fn({ id, message, type, duration }));
  return id;
}

const ICONS = {
  success: <CheckCircle size={18} />,
  error: <AlertCircle size={18} />,
  info: <Info size={18} />,
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts(list => list.filter(t => t.id !== id));
  }, []);

  useEffect(() => {
    const handler = (toast) => {
      setToasts(list => [...list, toast]);
      if (toast.duration > 0) {
        setTimeout(() => remove(toast.id), toast.duration);
      }
    };
    listeners.push(handler);
    return () => { listeners = listeners.filter(fn => fn !== handler); };
  }, [remove]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" role="region" aria-live="polite">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}`}>
          <span className="toast-icon">{ICONS[t.type] || ICONS.info}</span>
          <span className="toast-message">{t.message}</span>
          <button
            type="button"
            className="toast-close"
            onClick={() => remove(t.id)}
            aria-label="Dismiss"
          >
            <X size={15} />
          </button>
        </div>
      ))}
    </div>
  );
}